import Swal from 'sweetalert2';
import withReactContent, { ReactSweetAlertOptions } from 'sweetalert2-react-content';

const getBaseSweetAlert = (options: ReactSweetAlertOptions): typeof Swal => {
  const ReactSwal = withReactContent(Swal);
  const swal = ReactSwal.mixin(options);

  return swal;
};

export default getBaseSweetAlert;
